<template>
    <custom-upload-image :file-list="fileList" :max-upload-image-limit="fileNumber || 5" :image-size-limit="fileSize || 100" @on-change="handleChange" />
</template>

<script>
import CustomUploadImage from '@/components/CustomUploadImage'

export default {
    name: 'UploadImage',
    components: {
        CustomUploadImage
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        fileNumber: {
            type: Number,
            default: 5
        },
        fileSize: {
            type: Number
        }
    },
    computed: {
        fileList: {
            get() {
                let _fileList = []
                try {
                    _fileList = JSON.parse(this.value || '[]')

                    if (!Array.isArray(_fileList)) {
                        throw Error('数据格式不对')
                    }
                } catch (e) {
                    console.log(e.message)
                    _fileList = []
                }

                return _fileList
            },
            set() {
                // console.log('lll', val)
                // this.$emit('input', JSON.stringify(val))
                // this.$emit('change', JSON.stringify(val))
            }
        }
    },
    methods: {
        handleChange(fileList) {
            try {
                if (fileList.length > 0) {
                    this.$emit('input', JSON.stringify(fileList))
                    this.$emit('change', JSON.stringify(fileList))
                } else {
                    this.$emit('input', '')
                    this.$emit('change', '')
                }
            } catch (error) {
                console.log(error)
                this.$emit('input', '')
                this.$emit('change', '')
            }
        }
    }
}
</script>

<style></style>
